import * as Yup from 'yup';

export const LoginSchema = {
  schema: Yup.object().shape({
    username: Yup.string()
      .required("Username is required")
      .when("usertype", {
        is: "employee",
        then: (schema) =>
          schema.test(
            "is-valid-employee-username",
            "Enter a valid mobile number, chola/chola1 email, or Employee ID",
            function (value) {
              if (!value) return false;

              const mobileRegex = /^[6-9]\d{9}$/;
              const alphanumericRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/;
              const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in)$/i;

              if (/^\d+$/.test(value)) {
                return mobileRegex.test(value);
              }

              if (value.includes("@")) {
                const [, domainPart] = value.split("@");
                const domain = domainPart?.split(".")[0]?.toLowerCase();
                return (
                  emailRegex.test(value) &&
                  (domain === "chola" || domain === "chola1")
                );
              }

              // ✅ Employee ID (alphanumeric)
              return alphanumericRegex.test(value);
            }
          ),
        otherwise: (schema) =>
          schema.when("usertype", {
            is: "dealer",
            then: (innerSchema) =>
              innerSchema.test(
                "is-valid-dealer-username",
                "Enter a valid mobile number, email, or Dealer ID",
                function (value) {
                  if (!value) return false;

                  const mobileRegex = /^[6-9]\d{9}$/;
                  const alphanumericRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/;
                  const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in)$/i;

                  if (/^\d+$/.test(value)) {
                    return mobileRegex.test(value);
                  }

                  if (value.includes("@")) {
                    return emailRegex.test(value);
                  }

                  // ✅ Dealer ID (alphanumeric)
                  return alphanumericRegex.test(value);
                }
              ),
            otherwise: (innerSchema) =>
              innerSchema.test(
                "is-valid-normal-username",
                "Enter a valid mobile number or email",
                function (value) {
                  if (!value) return false;

                  const mobileRegex = /^[6-9]\d{9}$/;
                  const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in)$/i;

                  if (/^\d+$/.test(value)) {
                    return mobileRegex.test(value);
                  }

                  if (value.includes("@")) {
                    return emailRegex.test(value);
                  }

                  return false; // ❌ For others, alphanumeric IDs are not allowed
                }
              ),
          }),
      }),
    mobileNumber: Yup.string()
      .notRequired(),
    password: Yup.string()
      .notRequired() // Password is handled in the modal, not in initial form
  }),

  // Add modal validation schema for password and OTP
  modalSchema: Yup.object().shape({
    password: Yup.string()
      .when('isMobileLogin', {
        is: false,
        then: (schema) => schema.required('Password is required'),
        otherwise: (schema) => schema.notRequired()
      }),
    otp: Yup.string()
      .min(6, 'OTP must be 6 digits')
      .required('OTP is required')
  })
};